import { render, staticRenderFns } from "./DashboardSettingsModal.vue?vue&type=template&id=21d2e730&scoped=true&"
import script from "./DashboardSettingsModal.vue?vue&type=script&lang=ts&"
export * from "./DashboardSettingsModal.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSettingsModal.vue?vue&type=style&index=0&id=21d2e730&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2e730",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VCardTitle,VCol,VRow,VSpacer})
